import { useState, useContext, useRef } from "react";
import moment from "moment";

import { getAAFFs, getListadoAaffsSupp, noRealizada } from "../services";
import { UsuarioContext } from "../providers/userContext";
import {  useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../functions/parametrosURL/funcionesParamsURL';


const formatData = (data) => {



  return data.map((row) => ({
    razonSocial: row.razonSocial || row.propertie?.aaff?.nombreContacto,
    nif: row.nif || row.propertie?.nif,
    parent_id: row.parent_id,
    // fechaEncargo: moment(row.fechaEncargo).format("DD/MM/YYYY"),
    id: row.id,
    // communityNumbers: row.properties ?? [],
    direction: row.direccion || row.propertie?.direccion,
    cp: row.codigoPostal || row.propertie?.codigoPostal,
    provincia: row.provincia || row.propertie?.provincia,
    municipio: row.municipio || row.propertie?.municipio,
    empleados: (row.trabajadores || row.propertie?.trabajadores) ?? "No",
    servicios: row.gestionadaPor || row.propertie?.gestionadaPor,
    hojasVisita: row.visitSheets,
    visitadas: row.visitadasVentasUltima + row.renovadasVisitadasVentasUltima ?? 0,
    comunidades: row.pendientesCount + row.visitadasCount + row.renovadasCount + row.renovadasVisitadasCount ?? 0,
    communityPercent: row.communityPercent ?? 0,
    telefono: row.telefono || row.propertie?.telefono,
    unRealized: row.unRealized,
    unRealizedDate: row.unRealizedDate,
    observacionNoVisita: row.observacionNoVisita,
    comentarioNoVisita: row.comentarioNoVisita,
    unRealizedKae: row.unRealizedKae,
    unRealizedDateKae: row.unRealizedDateKae,
    unRealizedObservationsKae: row.unRealizedObservationsKae,
    unRealizedCommentsKae: row.unRealizedCommentsKae,
    technicians: row.technicians,
    propCaducadas: row.hasPropCaducadas,
  }));
};

function useAFFs(busqueda) {
  
  const {filtroOrder} = useRecogerURLParamsFiltros();
  const { rol } = useContext(UsuarioContext)
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const [loading, setLoading] = useState(true);
  
  const refControladorAborto = useRef(null);

  
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();

  const fetchData = async ({ offset, limit, filtros = busqueda,  order,orderBy } = {}) => {

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';
    
 
    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,order, orderBy);
    const payload = {
      params: { page: offset, limit:limit,order, orderBy },
      filtros,
      signal: nuevoControladorAborto.signal,
    };

    try {
      setLoading(true);

      let response = []
      if (rol === 'SUPP') {
        response = await getListadoAaffsSupp(payload);
        // console.log(response);
      } else {
        response = await getAAFFs(payload);
      }

      

      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") return;
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  return {
    data,
    fetchData,
    loading,
    // limit
  };
}

export default useAFFs;
